import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';

import { API_ENDPOINT, AUTH_HEADERS } from "../../../config/ApiConstants"
import * as types from "./types";
import { getNewAxiosInstance } from '../../../utils/axiosUtil';

function* fetchNews() {
    try {
        const axiosInstance = getNewAxiosInstance();
        const response = yield call(axiosInstance.get,`${API_ENDPOINT}/article`);
        yield put({ type: types.NEWS_LIST_RECEIVE, payload: response.data });
    } catch (e) {
        yield put({ type: types.NEWS_LIST_FAILURE, payload: { error: e.message } });
    }
}

function* fetchNewsDetails(action) {
    try {
        const { slug } = action.payload;
        const axiosInstance = getNewAxiosInstance();
        const response = yield call(axiosInstance.get, `${API_ENDPOINT}/article/${slug}`);
        yield put({ type: types.NEWS_DETAILS_RECEIVE, payload: response.data });
    } catch (e) {
        yield put({ type: types.NEWS_DETAILS_FAILURE, payload: { error: e.message } });
    }
}

export default function* fetchNewsSaga() {
    yield takeLatest(types.NEWS_LIST_REQUEST, fetchNews);
    yield takeLatest(types.NEWS_DETAILS_REQUEST, fetchNewsDetails);
}
